import React, { useState } from "react";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { useEffect } from "react";
import UserProfile from "../../../Common/UserProfile";

const TeamAdminProfileDetails = () => {
  const teamId = getFromLocalStorage("coachId");
  const schoolId = getFromLocalStorage("schoolId");
  const [teamAdminData, setTeamAdminData] = useState({});
  const [assignSportsList, setAssignSportsList] = useState([]);
  const [groupAthletes, setGroupAthletes] = useState([]);
  const [activeSports, setActiveSports] = useState([]);
  const [adminRightsList, setAdminRightsList] = useState([]);
  const [activeRightsList, setactiveRightsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTeamAdminData();
  }, []);

  const getTeamAdminData = () => {
    setLoading(true);
    userService
      .getTeamAdminById(teamId)
      .then((res) => {
        const data = res.data.data;
        setActiveSports(data.sports.map((item) => item.id));
        setactiveRightsList(data.permissionsRights.map((item) => item.id));
        setTeamAdminData(data);
        setGroupAthletes(data.groupAdminResponses);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getFilterSports();
    getAssignRightList();
  }, []);

  const getFilterSports = () => {
    userService.getSports(schoolId).then((response) => {
      if (response.data.status == true) {
        const filterSports = response.data.data;
        setAssignSportsList(filterSports);
      }
    });
  };
  const getAssignRightList = () => {
    userService.getAllPermissions().then((response) => {
      if (response.data.status == true) {
        const permissions = response.data.data.filter((item) => item.id !== 5);
        setAdminRightsList(permissions);
      }
    });
  };

  return (
    <div>
      <UserProfile
        schoolData={teamAdminData}
        groupAthletes={groupAthletes}
        assignSportsList={assignSportsList}
        activeSports={activeSports}
        adminRightsList={adminRightsList}
        activeRightsList={activeRightsList}
        flag="teamAdmin"
        URL="/manageteamadminprofile"
        loading={loading}
      />
    </div>
  );
};

export default TeamAdminProfileDetails;
